<template>
  <div>
    <div class="paymentOptions">
      <p class="fs-36 color-black bold">{{ trans['payment_options'] }}</p>

      <div
        :class="paymentOptionClass('full')"
        class="checkboxLg"
        @click="selectPaymentOption('full')"
      >
        <div class="fs-24 medium">{{ trans.purchase }}</div>
        <div class="d-flex">
          <div class="fs-17">{{ trans.amount }}</div>
          <div class="fs-17">{{ trans['full_payment_option'] }}</div>
        </div>
        <div v-if="showPreSaleFullPrice" class="d-flex">
          <div class="fs-17">{{ trans['ex_price'] }}</div>
          <div class="fs-17 bold">
            {{ preSalePrice }}
          </div>
        </div>
        <div v-if="showFullPrice" class="d-flex">
          <div class="fs-17">{{ trans.purchase }}</div>
          <div class="fs-17 bold">
            {{ fullPrice }}
          </div>
        </div>
        <div v-if="hasExtra" class="d-flex">
          <div class="fs-12">Extra</div>
          <div class="fs-12 text-right">
            <div v-for="item in extra" class="d-block">
              {{ item.title }} {{ itemBalance(item) }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showReservationOption"
        :class="paymentOptionClass('reservation')"
        class="checkboxLg"
        @click="selectPaymentOption('reservation')"
      >
        <div
          class="fs-24 medium"
        >
          {{ trans['reservation_option'] }}
        </div>
        <div class="d-flex">
          <div class="fs-17">{{ trans.amount }}</div>
          <div class="fs-17">
            {{ reservationPrice }}
          </div>
        </div>
        <div v-if="hasExtra" class="d-flex">
          <div class="fs-12">{{ trans.extra }}</div>
          <div class="fs-12 text-right">
            <div v-for="item in extra" class="d-block">
              {{ item.title }} {{ itemBalance(item) }}
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="fs-17">{{ trans['purchase_price'] }}</div>
          <div class="fs-17 bold">
            {{ fullPrice }}
          </div>
        </div>
      </div>
    </div>
    <div class="chooseBike-text">
      <p class="fs-11 color-gray">
        {{ trans.this }} {{ reservationPrice }} {{ trans['confirm_limited'] }} {{ buildTitle }}
        {{ trans['selected_size'] }}
      </p>
      <br/>
      <p class="fs-11 color-gray">
        {{ trans['pending_amount'] }} {{ reservationDiff }} {{ trans.fulfilled }}
      </p>
      <br/>
      <p class="fs-11 color-gray">
        {{ trans['tax_included'] }}
      </p>
      <br/>
      <p class="fs-11 color-gray">
        {{ trans["customer_outside_eu"] }}
      </p>
      <br/><br/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BuildPaymentOptionSelector",
  props: ['trans'],
  computed: {
    ...mapGetters({
      build: 'build/selectedBuild',
      extra: "build/extra",
      selectedPaymentOption: "build/selectedPaymentOption",
    }),
    showPreSaleFullPrice() {
      return this.validPresaleDate
    },
    showFullPrice() {
      return !this.validPresaleDate
    },
    zeroStock() {
      return this.build['stock'] === 0
    },
    validPresaleDate() {
      let presaleRule = false
      if (this.build['pre_sale_start'] && this.build['pre_sale_end']) {
        presaleRule = this.$moment(this.$moment.now()).isBetween(this.build['pre_sale_start'], this.build['pre_sale_end'])
      } else {
        return false
      }
      return presaleRule
    },
    showReservationOption() {
      return this.zeroStock
    },
    reservationPriceClean() {
      return this.build['prices']['res_price_for_eu']
    },
    reservationPrice() {
      return this.$crConverter(this.reservationPriceClean / 100, 'EUR')
    },
    hasExtra() {
      return this.extra.length > 0
    },
    buildTitle() {
      return this.build.title
    },
    preSalePriceClean() {
      return this.build['prices']['ex_price_for_eu'];
    },
    preSalePrice() {
      return this.$crConverter(this.preSalePriceClean / 100, 'EUR')
    },
    reservationDiff() {
      let diff = this.fullPriceClean - this.reservationPriceClean;
      return this.$crConverter(diff / 100, 'EUR')
    },
    fullPriceClean() {
      return this.build['prices']['price_for_eu']
    },
    fullPrice() {
      return this.$crConverter(this.fullPriceClean / 100, 'EUR')
    },
  },
  methods: {
    isSelected(type) {
      return this.selectedPaymentOption === type
    },
    paymentOptionClass(type) {
      return {
        active: this.isSelected(type)
      }
    },
    selectPaymentOption(type) {
      this.$store.commit('build/setSelectedPaymentOptions', type)
    },
    itemBalance(item) {
      return this.$crConverter(item.price / 100, 'EUR', '%s +%v')
    },
  }
}
</script>
